/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
/* eslint-disable no-restricted-imports */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { makeStyles } from "@material-ui/core/styles";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const menuItemStyle = {
    fontSize: "1.143rem",
    marginTop: "3px"
  };
  const subItemStyle = {
    fontSize: "1.143rem",
    marginTop: "9px"
  };
  const expandStyle = {
    flex: "0 0 24px",
    fontSize: "1.143rem",
    marginTop: "3px"
  };
  const iconStyle = {
    flex: "0 0 24px"
  };
  const subIconStyle = {
    flex: "0 0 24px",
    marginLeft: "28px"
  };
  const singleStyle = {
    fontSize: "1.143rem",
    marginLeft: "-10px",
    marginTop: "3px"
    // flex: "0 0 24px"
  };

  const useStyles = makeStyles(theme => ({
    selectedStyle: {
      color: "#1c064d"
    }
  }));

  const Styles = useStyles();
  const showOriginal = false;
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open`
      : "";
  };

  return (
    <>
      <div
        style={{
          color: "#123456",
          width: "210px",
          fontSize: "2rem",
          marginTop: "8px",
          marginBottom: "16px",
          // fontFamily: 'Do Hyeon',
          // textShadow: '2px 2px 2px darkgrey',
          fontWeight: "bold",
          textAlign: "center"
        }}
      >
        {" "}
        (주)클라이언트
        <img
          alt="Logo"
          style={{
            width: "24px",
            float: "right",
            marginTop: "4px",
            marginRight: "1rem"
          }}
          src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")}
        />
      </div>

      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/dashboard",
            false
          )}`}
          aria-haspopup="true"
          // data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/dashboard">
            <span className="svg-icon menu-icon" style={{ marginLeft: "24px" }}>
              <img
                src={
                  checkIsActive(location, "/dashboard")
                    ? toAbsoluteUrl("/media/images/png/icon_draft_5@3x.png")
                    : toAbsoluteUrl("/media/images/png/icon_draft_4@3x.png")
                }
                width={16}
                height={16}
                alt=""
              />
            </span>
            <span style={singleStyle}>대시보드</span>
          </NavLink>
        </li>

        <li
        className={`menu-item`}
          // className={`menu-item ${getMenuItemActive(
          //   "/allAccount",
          //   false
          // )} ${getMenuItemActive("/group", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/allAccount">
            <span className="svg-icon menu-icon" style={expandStyle}>
              <SVG src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")} />
            </span>
            <span className="svg-icon menu-icon" style={iconStyle}>
              <SVG
                src={toAbsoluteUrl("/media/images/icon_account_2.svg")}
                width={16}
                height={16}
              />

              {/* <img
                src={
                  checkIsActive(location, "/allAccount") ||
                  checkIsActive(location, "/group")
                    ? toAbsoluteUrl("/media/images/png/icon_account_5@3x.png")
                    : toAbsoluteUrl("/media/images/png/icon_account_4@3x.png")
                }
                width={18}
                height={18}
                alt=""
              /> */}
            </span>
            <span style={menuItemStyle}>계정</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="svg-icon menu-icon" style={expandStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")}
                  />
                </span>
                <span className="svg-icon menu-icon" style={subIconStyle}>
                  <SVG src={toAbsoluteUrl("/media/images/icon_draft.svg")} />
                </span>
                <span className="menu-link">
                  <span style={menuItemStyle}>계정</span>
                </span>
              </li> */}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/allAccount")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/allAccount">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_account.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/allAccount")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_account_5@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_account_4@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>전체계정</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/group")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/group">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_group.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/group")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_group_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_group_2@3x.png"
                            )
                      }
                      width={14}
                      height={14}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>그룹</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        <li
        className={`menu-item`}
          // className={`menu-item ${getMenuItemActive(
          //   "/option",
          //   false
          // )} ${getMenuItemActive("/allMail", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/option">
            <span className="svg-icon menu-icon" style={expandStyle}>
              <SVG src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")} />
            </span>
            <span className="svg-icon menu-icon" style={iconStyle}>
              <SVG
                src={toAbsoluteUrl("/media/images/icon_operation.svg")}
                width={16}
                height={16}
              />

              {/* <img
                src={
                  checkIsActive(location, "/option") ||
                  checkIsActive(location, "/allMail")
                    ? toAbsoluteUrl(
                        "/media/images/png/icon_operation_4@3x.png"
                      )
                    : toAbsoluteUrl(
                        "/media/images/png/icon_operation_3@3x.png"
                      )
                }
                width={16}
                height={16}
                alt=""
              /> */}
            </span>
            <span style={menuItemStyle}>운영</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="svg-icon menu-icon" style={expandStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")}
                  />
                </span>
                <span className="svg-icon menu-icon" style={iconStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_operation.svg")}
                  />
                </span>
                <span className="menu-link">
                  <span style={menuItemStyle}>운영</span>
                </span>
              </li> */}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/option")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/option">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_operation.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/option")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_operation_4@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_operation_3@3x.png"
                            )
                      }
                      width={16}
                      height={16}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>옵션설정</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              {/* <li
                className={`menu-item ${getMenuItemActive("/allMail")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/allMail">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    <img
                      src={
                        checkIsActive(location, "/allMail")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_mail_to_me_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_mail_to_me@3x.png"
                            )
                      }
                      width={16}
                      height={16}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>전체메일</span>
                </NavLink>
              </li> */}
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        <li
        className={`menu-item`}
          // className={`menu-item ${getMenuItemActive(
          //   "/mta",
          //   false
          // )} ${getMenuItemActive("/pop3", false)} ${getMenuItemActive(
          //   "/imap",
          //   false
          // )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/web">
            <span className="svg-icon menu-icon" style={expandStyle}>
              <SVG src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")} />
            </span>
            <span className="svg-icon menu-icon" style={iconStyle}>
              <SVG
                src={toAbsoluteUrl(
                  "/media/images/icon_service_management.svg"
                )}
                width={16}
                height={16}
              />
              {/* <img
                src={
                  checkIsActive(location, "/mta") ||
                  checkIsActive(location, "/pop3") ||
                  checkIsActive(location, "/imap")
                    ? toAbsoluteUrl(
                        "/media/images/png/icon_service_management_4@3x.png"
                      )
                    : toAbsoluteUrl(
                        "/media/images/png/icon_service_management_3@3x.png"
                      )
                }
                width={16}
                height={16}
                alt=""
              /> */}
            </span>
            <span style={menuItemStyle}>서비스설정</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="svg-icon menu-icon" style={expandStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")}
                  />
                </span>
                <span className="svg-icon menu-icon" style={iconStyle}>
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/images/icon_service_management.svg"
                    )}
                  />
                </span>
                <span className="menu-link">
                  <span style={menuItemStyle}>서비스설정</span>
                </span>
              </li> */}
              {/*begin::2 Level*/}
              {/* <li
                className={`menu-item ${getMenuItemActive("/web")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/web">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    <SVG
                      src={toAbsoluteUrl("/media/images/icon_web.svg")}
                      width={18}
                      height={18}
                    />
                  </span>
                  <span style={subItemStyle}>WEB</span>
                </NavLink>
              </li> */}
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/mta")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/mta">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_web.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/mta")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_smtp_3@3x.png"
                            )
                          : toAbsoluteUrl("/media/images/png/icon_smtp@3x.png")
                      }
                      width={16}
                      height={16}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>MTA</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/pop3")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/pop3">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_web.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/pop3")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_smtp_3@3x.png"
                            )
                          : toAbsoluteUrl("/media/images/png/icon_smtp@3x.png")
                      }
                      width={16}
                      height={16}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>POP</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/imap")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/imap">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_web.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/imap")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_smtp_3@3x.png"
                            )
                          : toAbsoluteUrl("/media/images/png/icon_smtp@3x.png")
                      }
                      width={16}
                      height={16}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>IMAP</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        <li
          className={`menu-item`}
          // className={`menu-item ${getMenuItemActive("/backup", false)} ${getMenuItemActive("/restore", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/backup">
            <span className="svg-icon menu-icon" style={expandStyle}>
              <SVG src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")} />
            </span>
            <span className="svg-icon menu-icon" style={iconStyle}>
              <SVG
                src={toAbsoluteUrl("/media/images/icon_backup_2.svg")}
                width={18}
                height={18}
              />
              {/* <img
                src={
                  checkIsActive(location, "/backup") ||
                  checkIsActive(location, "/restore")
                    ? toAbsoluteUrl(
                        "/media/images/png/icon_backup_restore_4@3x.png"
                      )
                    : toAbsoluteUrl(
                        "/media/images/png/icon_backup_restore@3x.png"
                      )
                }
                width={16}
                height={16}
                alt=""
              /> */}
            </span>
            <span style={menuItemStyle}>백업/복구</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/backup")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/backup">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_backup_2.svg")}
                      width={18}
                      height={18}
                    /> */}
                    <img
                      src={
                        checkIsActive(location, "/backup")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_backup_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_backup_2@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>백업</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive("/restore")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/restore">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    {/* <SVG
                      src={toAbsoluteUrl("/media/images/icon_restore_2.svg")}
                      width={18}
                      height={18}
                    /> */}

                    <img
                      src={
                        checkIsActive(location, "/restore")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_restore_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_restore@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>복구</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/chart",
            false
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/chart">
            <span className="svg-icon menu-icon" style={{ marginLeft: "24px" }}>
              <SVG src={toAbsoluteUrl("/media/images/icon_draft_6.svg")} />
            </span>
            <span style={singleStyle}>통계</span>
          </NavLink>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/security",
            false
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/security">
            <span className="svg-icon menu-icon" style={{ marginLeft: "24px" }}>
              <SVG src={toAbsoluteUrl("/media/images/icon_draft_8.svg")} />
            </span>
            <span style={singleStyle}>보안</span>
          </NavLink>
        </li>

        {/* <li
          className={`menu-item ${getMenuItemActive(
            "/inMail",
            false
          )} ${getMenuItemActive("/outMail", false)} ${getMenuItemActive(
            "/trashMail",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/inMail">
            <span className="svg-icon menu-icon" style={expandStyle}>
              <SVG src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")} />
            </span>
            <span className="svg-icon menu-icon" style={iconStyle}>
              <img
                src={
                  checkIsActive(location, "/inMail") ||
                  checkIsActive(location, "/outMail") ||
                  checkIsActive(location, "/trashMail")
                    ? toAbsoluteUrl(
                        "/media/images/png/icon_inspection_4@3x.png"
                      )
                    : toAbsoluteUrl(
                        "/media/images/png/icon_inspection_3@3x.png"
                      )
                }
                width={16}
                height={16}
                alt=""
              />
            </span>

            <span style={menuItemStyle}>감사</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="svg-icon menu-icon" style={expandStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_arrow_up.svg")}
                  />
                </span>
                <span className="svg-icon menu-icon" style={subIconStyle}>
                  <SVG
                    src={toAbsoluteUrl("/media/images/icon_inspection.svg")}
                  />
                </span>
                <span className="menu-link">
                  <span style={menuItemStyle}>감사</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/inMail")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/inMail">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    <img
                      src={
                        checkIsActive(location, "/inMail")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_mail_received_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_mail_received_2@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>수신</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/outMail")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/outMail">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    <img
                      src={
                        checkIsActive(location, "/outMail")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_mail_send_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_mail_send_2@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>발신</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/trashMail")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/trashMail">
                  <span className="svg-icon menu-icon" style={subIconStyle}>
                    <img
                      src={
                        checkIsActive(location, "/trashMail")
                          ? toAbsoluteUrl(
                              "/media/images/png/icon_mail_deleted_3@3x.png"
                            )
                          : toAbsoluteUrl(
                              "/media/images/png/icon_mail_deleted@3x.png"
                            )
                      }
                      width={18}
                      height={18}
                      alt=""
                    />
                  </span>
                  <span style={subItemStyle}>삭제</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li> */}
      </ul>

      {showOriginal ? (
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          {/*begin::1 Level*/}

          <li
            className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span style={menuItemStyle}>Dashboard</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/builder", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/builder">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")} />
              </span>
              <span style={menuItemStyle}>Layout Builder</span>
            </NavLink>
          </li>

          <li className="menu-section ">
            <h4 style={menuItemStyle}>Components</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>

          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/google-material",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/google-material">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Cap-2.svg")} />
              </span>
              <span style={menuItemStyle}>Material UI</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span style={menuItemStyle}>Material UI</span>
                  </span>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/inputs",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/inputs"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Inputs</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu ">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      {/*begin::3 Level*/}
                      <li
                        className={`menu-item  ${getMenuItemActive(
                          "/google-material/inputs/autocomplete"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/autocomplete"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Autocomplete</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/buttons"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/buttons"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Buttons</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/checkboxes"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/checkboxes"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Checkboxes</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/pickers"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/pickers"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Pickers</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/radio-buttons"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/radio-buttons"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Radio Buttons</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/selects"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/selects"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Selects</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/switches"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/switches"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Switches</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/text-fields"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/text-fields"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Text Fields</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/inputs/transfer-list"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/inputs/transfer-list"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Transfer List</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu  ${getMenuItemActive(
                    "/google-material/navigation",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/navigation"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Navigation</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/bottom-navigation"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/bottom-navigation"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Bottom Navigation</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/breadcrumbs"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/breadcrumbs"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Breadcrumbs</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/drawern"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/drawer"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Drawers</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/links"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/links"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>NavLinks</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/menus"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/menus"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Menus</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/steppers"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/steppers"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Steppers</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/navigation/tabs"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/navigation/tabs"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Tabs</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/surfaces",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/surfaces"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Surfaces</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/surfaces/app-bar"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/surfaces/app-bar"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>App Bar</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/surfaces/paper"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/surfaces/paper"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Paper</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/surfaces/cards"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/surfaces/cards"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Cards</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/surfaces/expansion-panels"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/surfaces/expansion-panels"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Expansion Panels</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/feedback",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/feedback"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Feedback</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/feedback/progress"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/feedback/progress"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Progress</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/feedback/dialogs"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/feedback/dialogs"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Dialogs</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/feedback/snackbars"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/feedback/snackbars"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Snackbars</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/data-displays",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/data-displays"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Data Display</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/avatars"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/avatars"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Avatars</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/badges"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/badges"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Badges</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/chips"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/chips"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Chips</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/dividers"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/dividers"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Dividers</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/icons"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/icons"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Icons</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/lists"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/lists"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Lists</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/tables"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/tables"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Tables</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/tooltips"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/tooltips"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Tooltips</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/data-displays/typography"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/data-displays/typography"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Typography</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/utils",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/utils"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Utils</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/click-away-listener"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/click-away-listener"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Click Away Listener</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/no-ssr"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/no-ssr"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>No SSR</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/popover"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/popover"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Popover</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/popper"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/popper"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Popper</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/portal"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/portal"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Portal</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/transitions"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/transitions"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Transitions</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/utils/use-media-query"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/utils/use-media-query"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>useMediaQuery</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/google-material/layout",
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/google-material/layout"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Layout</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/layout/box"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/layout/box"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Box</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/layout/container"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/layout/container"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Container</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/layout/grid"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/layout/grid"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Grid</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/layout/grid-list"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/layout/grid-list"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Grid list</span>
                        </NavLink>
                      </li>

                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/google-material/layout/hidden"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/google-material/layout/hidden"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span style={menuItemStyle}>Hidden</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}
                />
              </span>
              <span style={menuItemStyle}>Bootstrap</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span style={menuItemStyle}>Bootstrap</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/alert"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/alert">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Alerts</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/badge"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/badge">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Badge</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/breadcrumb"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/breadcrumb"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Breadcrumb</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/buttons"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/buttons"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Buttons</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/button-group"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/button-group"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Button Group</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/cards"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/cards">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Cards</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/carousel"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/carousel"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Carousel</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/dropdowns"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/dropdowns"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Dropdowns</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/forms"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/forms">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Forms</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/input-group"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/input-group"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Input Group</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/images"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/images">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Images</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/figures"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/figures"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Figures</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/jumbotron"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/jumbotron"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Jumbotron</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/list-group"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/list-group"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>List group</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/modal"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/modal">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Modal</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/navs"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/navs">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Navs</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/navbar"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/navbar">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Navbar</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/overlays"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/overlays"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Overlays</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/pagination"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/pagination"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Pagination</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/popovers"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/popovers"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Popovers</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/progress"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/progress"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Progress</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/spinners"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/spinners"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Spinners</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/table"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/table">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Table</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/tabs"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/tabs">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Tabs</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/tooltips"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/react-bootstrap/tooltips"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Tooltips</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/toasts"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/react-bootstrap/toasts">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span style={menuItemStyle}>Toasts</span>
                    </NavLink>
                  </li>
                </ul>
              </ul>
            </div>
          </li>

          <li className="menu-section ">
            <h4 style={menuItemStyle}>Applications</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>

          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/e-commerce",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/e-commerce">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")}
                />
              </span>
              <span style={menuItemStyle}>eCommerce</span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span style={menuItemStyle}>eCommerce</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/customers"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/customers">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Customers</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/products"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/products">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Products</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/user-profile", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/user-profile">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Add-user.svg"
                  )}
                />
              </span>
              <span style={menuItemStyle}>User Profile</span>
            </NavLink>
          </li>

          <li className="menu-section ">
            <h4 style={menuItemStyle}>Custom</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>

          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/error",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/error">
              <span className="svg-icon menu-icon" style={iconStyle}>
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                />
              </span>
              <span style={menuItemStyle}>Error Pages</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span style={menuItemStyle}>Error Pages</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v1"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v1">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page - 1</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v2"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v2">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page -2</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v3"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v3">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page - 3</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v4"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v4">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page - 4</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v5"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v5">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page - 5</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/error/error-v6"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/error/error-v6">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span style={menuItemStyle}>Error Page - 6</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      ) : (
        ""
      )}

      {/* end::Menu Nav */}
    </>
  );
}
